import React, { useState, useEffect} from "react";
import './verify-email.css';
import {
    Col,
    Row,
    Container,
  } from "react-bootstrap";

import axios from 'axios';
import SyncLoader from "react-spinners/SyncLoader";
import ReactGA from 'react-ga';

export default function VerifyEmail(props) {
    ReactGA.pageview(window.location.pathname + window.location.search);    
    const [loading, setLoading] = useState(false);
    const [somethingWentWrong, setSomethingWentWrong] = useState(false);
    const [accountInfo, setAccountInfo] = useState({});
    const [verified, setVerified] = useState(false);
    const axiosConfig = {
        headers: {
            Authorization: props.match.params.token
        }
    };   

    useEffect(() => {
        setLoading(true);
        axios.post('https://uae-dentist-backend.herokuapp.com/account/verify-email', {_id : props.match.params._id}, axiosConfig)
        .then(function (response) {
            setLoading(false);
            setVerified(true);
            setAccountInfo(response.data)
            console.log(response)
        })
        .catch(function (error) {
            setSomethingWentWrong(true)
            setLoading(false);
            console.log(error);
        })
        // eslint-disable-next-line
    }, []);

    
    return (
    <Container className="mt-5 rounded">
    <Row>
    <Col id="" className="rounded p-5 mt-2 mb-2">


    { somethingWentWrong && "Something went wrong"}
    { verified && `Hello ${accountInfo.contact_person}, your email '${accountInfo.email}' has been successfully verified.`}

    <div className='mt-5'>
        <SyncLoader
        size={20}
        margin={3}
        color={"#123abc"}
        loading={loading}
        />
    </div>
    
    </Col>
    </Row>
    
    </Container>
    )
}